// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueI18n from 'vue-i18n'
import {
    messages
} from './components/common/i18n'
import './assets/css/icon.css'
import './components/common/directives'
import './assets/base.less'
import './assets/style.css'
import VueQriously from 'vue-qriously'
import md5 from 'js-md5'
import Cookies from 'js-cookie'
import {
    getToken,
    setToken,
    getUser,
	setUser
} from '@/utils/auth'
import BaiduMap from 'vue-baidu-map'
import Chat from 'jwchat'
// require('../mock/index')
import moment from 'moment'
Vue.prototype.$moment = moment
Vue.use(VueAxios, axios)
Vue.use(ElementUI, {
    size: 'small'
})
Vue.use(Chat)
Vue.use(VueI18n)
Vue.use(VueQriously)
Vue.prototype.$md5 = md5
Vue.prototype.$imgUrl = 'https://img.schoolface.cn/res/img/'
Vue.prototype.$imgUrlNew = 'https://res.schoolface.cn/res/img/'
// Vue.prototype.$zipCode = '3702'
Vue.prototype.$zipCode = '1311'

const i18n = new VueI18n({
    locale: 'zh',
    messages
})

// 百度地图
Vue.use(BaiduMap, {
    /* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
    ak: 'DjZENFZgQTpLBwGgkbp713TtC9lMDzub'
})

Vue.config.productionTip = false

// const user = getToken()
// if (user) {
//     Vue.prototype.$user = JSON.parse(user)
// }
//视频播放
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)


const whiteList = ['/login', '/password', '/updatePassword','/czsc'] // no redirect whitelist
router.beforeEach(async (to, from, next) => {
    // set page title
	if(to.query.result){
		if(JSON.parse(to.query.result)){
			if(JSON.parse(to.query.result).token){
				// router.go(0)
				setToken(JSON.parse(to.query.result).token)
				setUser(JSON.parse(to.query.result))
				Cookies.set('flag', true)
				router.push('/main')
				return false
			}
		}
	}
    document.title = `${to.meta.title} | 社会课堂`

    // determine whether the user has logged in
    const hasToken = getToken()
	console.log(getToken())
    const hasUser = getUser()
	console.log(getUser())
    if (hasToken && hasUser) {
        if (to.path === '/login' ) {
            // if is logged in, redirect to the home page
            next({
                path: '/'
            })
        } else {
            if (getUser()) {
                Vue.prototype.$cUser = JSON.parse(getUser())
            }
            setToken(hasToken)
            next()
        }
    } else {
    /* has no token */
        if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next()
        } else {
            // other pages that do not have permission to access are redirected to the login page.
            next(`/login?redirect=${to.path}`)
        }
    }
})

// 使用钩子函数对路由进行权限跳转
// router.beforeEach((to, from, next) => {
//     document.title = `${to.meta.title} | 社会课堂`
//     // const role = localStorage.getItem('ms_user')
//     if (!user && to.path !== '/login') {
//         next('/login')
//     } else {
//         if (to.meta.permission) {
//             // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
//             user.username === 'admin' ? next() : next('/403')
//         } else {
//             // if (to.path === '/login') {
//             //   next('/main')
//             // } else {
//             //   next()
//             // }
//             next()
//         }
//     }
//     // if (!role && to.path !== '/login') {
//     //   next('/login')
//     // } else if (to.meta.permission) {
//     //   // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
//     //   role === 'admin' ? next() : next('/403')
//     // } else {
//     //   // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
//     //   if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
//     //     Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
//     //       confirmButtonText: '确定'
//     //     })
//     //   } else {
//     //     next()
//     //   }
//     // }
// })
/* eslint-disable no-new */
new Vue({
    router,
    i18n,
    store,
    render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js